// extracted by mini-css-extract-plugin
module.exports = {"custom-padding":"CustomCard_custom-padding__MEqus","custom-radius":"CustomCard_custom-radius__hB3a6"};